import { render } from "./Chatroom.vue?vue&type=template&id=c0042910"
import script from "./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Norbert\\webdev\\udemy-vue3\\chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__